module.exports = __webpack_public_path__ + "static/media/robocupido.23434074.jpg";